import {
	fetchStorageLimitDataForProduct,
	fetchStorageLimitDataForProductWithTimestamp,
} from './fetch-storage-limit-data-for-product';

export const actions = {
	fetchStorageLimitDataForProduct,
	fetchStorageLimitDataForProductWithTimestamp,
} as const;
